import React from 'react';
import CountDown from '@components/countDown';
import ProductList from '../productList';
import { featuredRecord, lotteryRecordMockList } from '../mock';
import styles from './index.module.scss';

interface RecordContentProps {
    onItemClick?: (id: string) => void;
}

const RecordContent: React.FC<RecordContentProps> = ({ onItemClick }) => {
    const historyRecordList = lotteryRecordMockList.filter((item) => item.resultType !== 'ongoing');

    return (
        <div className={styles.content}>
            <div className={styles.featureCard} onClick={() => onItemClick && onItemClick(featuredRecord.id)}>
                <div className={styles.featureMain}>
                    <div className={styles.featureCover} />
                    <div className={styles.featureInfo}>
                        <div className={styles.featureTitle}>{featuredRecord.title}</div>
                        <div className={styles.countdownWrap}>
                            <CountDown number={featuredRecord.countdownTarget} endText="后结束" />
                        </div>
                        <div className={styles.featureButton}>{featuredRecord.buttonText}</div>
                    </div>
                </div>
                <div className={styles.tipBar}>
                    <span className={styles.tipIcon} />
                    <div className={styles.tipText}>{featuredRecord.tipText}</div>
                    <span className={styles.tipArrow} />
                </div>
            </div>

            <ProductList list={historyRecordList} onItemClick={onItemClick} />
        </div>
    );
};

export default RecordContent;
